<template>
  <div class="tokensListContainer">
    <p class="whiteMainTitle">{{ $t('flipCoinTooltip2') }}</p>
    <TavernTokensList :exchange-token-callback="exchangeTokenCallback" />
  </div>
</template>

<script lang="ts" setup>
import type { IFlipCoinTokenConfig } from '~/types/apiService';
import { PusherTabs } from '~/types/Pusher';
import type { Tokens } from '~/utils/constants';

const tokenToPlay = defineModel<Tokens>('token');
const activeTab = defineModel<PusherTabs>('activeTab');

const { blockchain } = useEnvs();

const exchangeTokenCallback = (token: IFlipCoinTokenConfig) => {
  tokenToPlay.value = tokenMetaData(blockchain.contracts, token.tokenAddress).name.contract as Tokens;
  activeTab.value = PusherTabs.PlaceBet;
};
</script>

<style lang="scss" scoped>
.tokensListContainer {
  width: 100%;
  height: 100%;
  padding-bottom: 85px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
</style>
